import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=740c0580"
import script from "./DateField.vue?vue&type=script&lang=ts"
export * from "./DateField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports